import React from 'react'
import { Tender } from '@/modules/Tenders/types'
import { Typogaphy } from 'vnetwork-ui'
import LinkIcons from '@/icons/LinkIcons'
import ClockIcons from '@/icons/ClockIcons'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

interface TenderListItemProps {
    /** Tender data */
    tender: Tender
    /** Days until closing */
    daysUntil: number
    /** Callback when item is clicked */
    onClick: (tender: Tender) => void
    /** Translation key for closing in text */
    closingInTranslationKey?: string
    /** Translation key for urgent badge */
    urgentTranslationKey?: string
}

const TenderListItem: React.FC<TenderListItemProps> = ({
    tender,
    daysUntil,
    onClick,
    closingInTranslationKey = 'closing_soon.closing_in',
    urgentTranslationKey = 'closing_soon.urgent',
}) => {
    const { t } = useTranslation('tenders')
    return (
        <div
            className="p-4 hover:bg-gray-50 transition-colors cursor-pointer"
            onClick={() => onClick(tender)}
        >
            <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-2">
                        <Typogaphy className="font-semibold text-gray-900 text-sm">
                            {tender.code}
                        </Typogaphy>
                        {tender.detail_url && (
                            <LinkIcons className="w-4 h-4 text-primary flex-shrink-0" />
                        )}
                    </div>
                    <Typogaphy className="text-gray-700 text-sm mb-2 line-clamp-2">
                        {tender.name}
                    </Typogaphy>
                    <div className="flex items-center gap-4 text-xs text-gray-500">
                        <div className="flex items-center gap-1">
                            <ClockIcons className="w-3 h-3" />
                            <span>
                                {t(closingInTranslationKey, {
                                    days: daysUntil,
                                })}
                            </span>
                        </div>
                        <span>
                            {dayjs(tender.bid_time).format('DD/MM/YYYY HH:mm')}
                        </span>
                    </div>
                </div>
                {daysUntil <= 5 && (
                    <div className="flex-shrink-0">
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-700">
                            {t(urgentTranslationKey)}
                        </span>
                    </div>
                )}
            </div>
        </div>
    )
}

export default TenderListItem
